import React from 'react';

import Logo from '../UI/game/header/images/logo.png';

import './styles.css';

// Top-level catch for any uncaught React render error. Without this,
// a thrown error inside the tree bubbles up to the router which renders
// a bare stack trace to the user. Class component because React error
// boundaries can't be implemented with hooks (getDerivedStateFromError
// / componentDidCatch have no hook equivalents).
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorId: null };
  }

  static getDerivedStateFromError() {
    // Short id displayed to the user so they can quote it to support.
    // Ties nothing to the actual stack yet; the value is just a
    // human-readable marker for the moment the crash happened.
    const errorId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`.toUpperCase();
    return { hasError: true, errorId };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary] caught render error:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.assign('/');
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="error-boundary-page">
        <div className="error-boundary-card">
          <img src={Logo} alt="Market Games" className="error-boundary-logo" />
          <h1 className="error-boundary-title">Something went wrong</h1>
          <p className="error-boundary-message">
            Sorry, an unexpected error stopped this page from loading. Try refreshing — if it keeps happening, contact support and include the code below.
          </p>
          <div className="error-boundary-id" aria-label="Error reference code">
            <span className="error-boundary-id-label">Error code</span>
            <code>{this.state.errorId}</code>
          </div>
          <div className="error-boundary-actions">
            <button type="button" className="button-red" onClick={this.handleReload}>
              Reload page
            </button>
            <button type="button" className="button-blue" onClick={this.handleGoHome}>
              Back to home
            </button>
          </div>
        </div>
      </div>
    );
  }
}
